import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import PrivateRoute from "PrivateRoute";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import moment from "moment";
import "./App.scss";
import "./index.css";

import { doLoginSSO, doLogout } from "./actions/authAction";
import { logEvent } from "firebase/analytics";
import { maintenancePageState } from "./actions/maintenanceAction";
import {
  BASE_URL,
  ID_CONSIGNEE,
  ID_RESELLER,
  ID_SHIPPER,
} from "./actions/constant";
import { analytics } from "./firebase";
import Tags from "./tags";
import RegisterShipper from "views/registerShipper";
import EmailForm from "views/registerShipper/email";
import { customParamsFetch } from "actions/ExpiredPiAction";
import ModalComponent from "views/registerShipper/modal";
import SimulasiTarif from "views/Pages/Portal/Content/simulasiTarif";
import DataUser from "views/Pages/Portal/Content/DataUser";
import { Dashboard } from "views";
// import Manifest from "views/Manifest/Manifest";
import { getUser, handleCallback } from "./authservice";

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

// Private
const Page404 = React.lazy(() => import("./views/Pages/Page404"));
const Page500 = React.lazy(() => import("./views/Pages/Page500"));
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/Pages/Login"));
const Register = React.lazy(() => import("./views/Pages/Register"));
const RegisterSuccess = React.lazy(() =>
  import("./views/Pages/Register/RegisterSuccess")
);
const ForgotPassword = React.lazy(() =>
  import("./views/Pages/ForgotPassword/ForgotPassword")
);
const ResetPassword = React.lazy(() =>
  import("./views/Pages/ForgotPassword/ResetPassword")
);
const ForgotPasswordSuccess = React.lazy(() =>
  import("./views/Pages/ForgotPassword/ForgotPasswordSuccess")
);
const Maintenance = React.lazy(() => import("./views/Pages/maintenancePage"));
const PiExpired = React.lazy(() => import("./views/Pages/PiExpired/PiExpired"));
const Landing = React.lazy(() => import("./views/LandingPage"));
const Portal = React.lazy(() => import("./views/Pages/Portal"));
const PortalJadwalOp = React.lazy(() =>
  import("./views/Pages/Portal/Content/JadwalPortal")
);
const PortalLanding = React.lazy(() =>
  import("./views/Pages/Portal/Content/LandingPage")
);
const PortalDetail = React.lazy(() =>
  import("./views/Pages/Portal/Content/Detail")
);
const ProdukPortal = React.lazy(() =>
  import("./views/Pages/Portal/Content/ProdukPortal")
);
const BiayaPengiriman = React.lazy(() =>
  import("./views/Pages/Portal/Content/BiayaPengiriman")
);
const Trayek = React.lazy(() => import("./views/Pages/Portal/Content/Trayek"));
const ManifestPrint = React.lazy(() => import("./views/Manifest/Manifest"));

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maintenance: false,
      preMaintenance: false,
      message: "",
      mulai: "",
      habis: "",
    };
  }

  componentDidMount() {
    this.cekMaintenance();
  }

  // componentDidUpdate(prevProps) {
  //   console.log(this.props.customParamsSuccess.isLoad, "update");
  //   if (
  //     this.props.isAuthenticated &&
  //     this.props.customParamsSuccess.isLoad === false
  //   ) {
  //     if (localStorage.getItem("tolaut@typeUser") == ID_SHIPPER) {
  //       this.props.customParamStatus("RENEWAL_SHIPPER_TOLERANCE");
  //       console.log(localStorage.getItem("tolaut@token"));
  //     }
  //   }
  // }

  cekMaintenance = async () => {
    let config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await fetch(BASE_URL + "check_maintenance", config);
      if (!res.ok) {
        throw Error(res.statusText);
      }
      const resJson = await res.json();
      if (resJson.status === 0) {
        this.props.maintenancePageState({
          maintenance: true,
          loginStat: true,
          role: "",
        });
      } else if (resJson.status === 1) {
        this.setState({
          preMaintenance: true,
          message: resJson.data[0].keterangan,
          mulai: resJson.data[0].tgl_jam_mulai,
          habis: resJson.data[0].tgl_jam_selesai,
        });
      }
      if (resJson.status === 400) {
        this.setState({ maintenance: false, preMaintenance: false });
      }
    } catch (error) {
      if (typeof error.json === "function") {
        error
          .json()
          .then((jsonError) => {
            console.log("Json error from API");
            console.log(jsonError);
          })
          .catch((genericError) => {
            console.log("Generic error from API");
            console.log(error.statusText);
          });
      } else {
        console.log("Fetch error");
        console.log(error);
        // window.alert("Error Connection");
      }
    }
  };

  close = () => {
    this.setState({ preMaintenance: false });
  };

  render() {
    // console.log(this.props.customParams);
    // console.log("PROPS ===>>> ", this.props);
    // console.log("STATE ===>>> ", this.state);

    logEvent(analytics, "screen_view", {
      firebase_screen: window.location.pathname,
      firebase_screen_class: window.location.pathname,
    });

    return (
      <React.Suspense fallback={loading()}>
        {process.env.REACT_APP_ENV && <Tags />}
        <Modal isOpen={this.state.preMaintenance}>
          <ModalHeader>Akan dilakukan maintenance pada sistem</ModalHeader>
          <ModalBody>
            <table>
              <tbody>
                <tr>
                  <td>
                    <strong>Mulai</strong>
                  </td>
                  <td>
                    <strong> : </strong>
                  </td>
                  <td>
                    {moment(this.state.mulai).format("DD MMMM YYYY, HH:mm:ss")}{" "}
                    WIB
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Selesai</strong>
                  </td>
                  <td>
                    <strong> : </strong>
                  </td>
                  <td>
                    {moment(this.state.habis).format("DD MMMM YYYY, HH:mm:ss")}{" "}
                    WIB
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Keterangan</strong>
                  </td>
                  <td>
                    <strong> : </strong>
                  </td>
                  <td>{this.state.message}</td>
                </tr>
              </tbody>
            </table>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.close}>
              Tutup
            </Button>
          </ModalFooter>
        </Modal>

        <Switch>
          <Route
            exact
            path="/maintenancepage"
            name="maintenance"
            render={(props) => <Maintenance {...props} />}
          />
          <Route
            exact
            path="/404"
            name="Page 404"
            render={(props) => <Page404 {...props} />}
          />
          <Route
            exact
            path="/500"
            name="Page 500"
            render={(props) => <Page500 {...props} />}
          />
          {this.props.maintenancePageData.maintenance &&
            this.props.maintenancePageData.loginStat &&
            localStorage.getItem("tolaut@typeUser") !== "6" && <Maintenance />}
          <Route
            exact
            path="/login"
            name="Page Login"
            render={(props) => (
              <Login
                isAuthenticated={this.props.isAuthenticated}
                customParams={this.props.customParams}
                {...props}
              />
            )}
          />
          {/* <Route path="/" exact component={Login} /> */}
          <Route
            path="/callback"
            // render={(props) => {
            //   handleCallback()
            //     .then(() => {
            //       getUser().then((user) => {
            //         this.setState({ user });
            //         return this.props.doLoginSSO();
            //         console.log("User logged in:", user);
            //       });
            //     })
            //     .catch((error) => {
            //       console.error("Login failed:", error);
            //     });
            //   // return <div>Loading...</div>;
            //   return <Login {...props} />;
            // }}
            render={() => {
              handleCallback()
                .then(() => getUser())
                .then((user) => {
                  return this.props.doLoginSSO(); // Panggil fungsi Redux untuk login SSO
                })
                .then(() => {
                  // Setelah berhasil login SSO, periksa apakah pengguna terautentikasi
                  // if (this.props.isAuthenticated) {
                  const userType = localStorage.getItem("tolaut@typeUser");
                  const expiredStatus = this.props.isExpired; // Ambil dari state Redux

                  if (
                    userType === ID_CONSIGNEE ||
                    userType === ID_RESELLER ||
                    userType === ID_SHIPPER
                  ) {
                    if (
                      expiredStatus.expired === "false" &&
                      expiredStatus.status === "0"
                    ) {
                      this.props.history.push("/expired/need-validate");
                    } else if (localStorage.getItem("tolaut@status") === "-7") {
                      window.alert(
                        "Anda perlu melakukan registrasi ulang sebagai shipper! Silakan klik menu Edit Profile."
                      );
                      this.props.history.push("/register-shipper");
                    } else {
                      this.props.history.push(
                        expiredStatus.expired === "true"
                          ? "/expired/true"
                          : userType === "14"
                          ? "/dashboard-leader"
                          : "/dashboard"
                      );
                    }
                  } else {
                    // Logika untuk jenis pengguna lain
                    if (userType === "14") {
                      this.props.history.push("/dashboard-leader");
                    } else {
                      this.props.history.push("/dashboard");
                    }
                  }
                  // }
                  //  else {
                  //   // Jika tidak terautentikasi, arahkan ke halaman login
                  //   this.props.history.push("/login");
                  // }
                })
                .catch((error) => {
                  console.error("Error:", error);
                  // this.props.history.push("/dashboard");
                });

              return <div>Loading...</div>; // Tampilkan loading saat memproses
            }}
            // render={() => {
            //   handleCallback()
            //     .then(() => getUser())
            //     .then((user) => {
            //       return this.props.doLoginSSO(); // Panggil fungsi Redux untuk login SSO
            //     })
            //     .then(() => {
            //       // Setelah berhasil login SSO, periksa status dan jenis pengguna
            //       const userType = localStorage.getItem("tolaut@typeUser");
            //       const expiredStatus = this.props.isExpired; // Ambil dari state Redux

            //       if (
            //         userType === ID_CONSIGNEE ||
            //         userType === ID_RESELLER ||
            //         userType === ID_SHIPPER
            //       ) {
            //         if (
            //           expiredStatus.expired === "false" &&
            //           expiredStatus.status === "0"
            //         ) {
            //           this.props.history.push("/expired/need-validate");
            //         } else if (localStorage.getItem("tolaut@status") === "-7") {
            //           window.alert(
            //             "Anda perlu melakukan registrasi ulang sebagai shipper! Silakan klik menu Edit Profile."
            //           );
            //           this.props.history.push("/register-shipper");
            //         } else {
            //           this.props.history.push(
            //             expiredStatus.expired === "true"
            //               ? "/expired/true"
            //               : userType === "14"
            //               ? "/dashboard-leader"
            //               : "/dashboard"
            //           );
            //         }
            //       } else {
            //         // Logika untuk jenis pengguna lain
            //         if (userType === "14") {
            //           this.props.history.push("/dashboard-leader");
            //         } else {
            //           this.props.history.push("/dashboard");
            //         }
            //       }
            //     })
            //     .catch((error) => {
            //       console.error("Error:", error);
            //       // this.props.history.push("/login");
            //     });

            //   return <div>Loading...</div>; // Tampilkan loading saat memproses
            // }}
          />
          <Route
            exact
            path="/register"
            name="Page Register"
            render={(props) => <Register {...props} />}
          />
          <Route
            exact
            path="/register/success"
            name="Page Register Success"
            render={(props) => <RegisterSuccess {...props} />}
          />
          <Route
            exact
            path="/forgot-password"
            name="Forgot Password"
            render={(props) => <ForgotPassword {...props} />}
          />
          <Route
            exact
            path="/reset-password/:token"
            name="Reset Password"
            render={(props) => <ResetPassword {...props} />}
          />
          <Route
            exact
            path="/forgot/password/success"
            name="Page Reset Password Success"
            render={(props) => <ForgotPasswordSuccess {...props} />}
          />
          <Route
            exact
            path="/expired/:status"
            name="Page Expired"
            render={(props) => <PiExpired {...props} />}
          />
          <Route
            exact
            path="/purchase-order/:token"
            name="Purchase Order"
            render={(props) => <Landing {...props} />}
          />
          <Route
            exact
            path="/detail/jadwal-kapal"
            name="Detail"
            render={(props) => (
              <Portal {...props} banner={true}>
                <PortalJadwalOp />
              </Portal>
            )}
          />
          <Route
            exact
            path="/detail/trayek"
            name="Detail"
            render={(props) => (
              <Portal {...props} banner={true}>
                <Trayek />
              </Portal>
            )}
          />
          <Route
            exact
            path="/detail/produk"
            name="Detail"
            render={(props) => (
              <Portal {...props} banner={true}>
                <ProdukPortal />
              </Portal>
            )}
          />
          <Route
            exact
            path="/detail/:name"
            name="Portal Sitolaut"
            render={(props) => (
              <Portal {...props} banner={false}>
                <PortalDetail {...props} />
              </Portal>
            )}
          />
          <Route
            exact
            path="/"
            name="Portal Sitolaut"
            render={(props) => (
              <Portal {...props} banner={true}>
                <PortalLanding />
              </Portal>
            )}
          />
          <Route
            exact
            path="/biaya-pengiriman"
            name="Biaya Pengiriman"
            render={(props) => (
              <Portal {...props} banner={true}>
                <BiayaPengiriman />
              </Portal>
            )}
          />
          <Route
            exact
            path="/simulasi-tarif"
            name="Simulasi Tarif"
            render={(props) => (
              <Portal {...props} banner={true}>
                <SimulasiTarif />
              </Portal>
            )}
          />
          <Route
            exact
            path="/data-users"
            name="Data Users"
            render={(props) => (
              <Portal {...props} banner={true}>
                <DataUser />
              </Portal>
            )}
          />
          <Route
            exact
            path="/register-shipper"
            name="Register Shipper"
            render={(props) => <RegisterShipper {...props} />}
          />
          <Route
            exact
            path="/modal-component"
            name="Modal Component"
            render={(props) => <ModalComponent {...props} />}
          />
          <Route
            exact
            path={"/manifest/print/qrcode/:itemId"}
            name="Manifest Validation"
            render={(props) => (
              <Portal {...props} banner={false}>
                <ManifestPrint {...props} />
              </Portal>
            )}
          />
          <Route
            exact
            path={"/manifest/print/qrcode/:itemId/:itemSpokeId"}
            name="Manifest Validation"
            render={(props) => (
              <Portal {...props} banner={false}>
                <ManifestPrint {...props} />
              </Portal>
            )}
          />

          <PrivateRoute
            path="/"
            name="Home"
            render={(props) => <DefaultLayout {...props} />}
            isAuthenticated={this.props.isAuthenticated}
          />
        </Switch>
      </React.Suspense>
    );
  }
}

App.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    maintenancePageData: state.maintenance.maintenancePageData,
    isAuthenticated: state.auth.isAuthenticated,
    customParams: state.ExpiredPI.MstCustomParam,
    customParamsSuccess: state.ExpiredPI.MstCustomParamSuccess,
    customParamsLoading: state.ExpiredPI.MstCustomParamLoading,
    customParamsError: state.ExpiredPI.MstCustomParamError,
    dataCustom: state.ExpiredPI,

    isExpired: state.auth.isExpired,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doLogout: () => dispatch(doLogout()),
    maintenancePageState: (val) => dispatch(maintenancePageState(val)),
    customParamStatus: (data) => dispatch(customParamsFetch(data)),
    doLoginSSO: () => dispatch(doLoginSSO()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
